export const getThrelteUserData = (object) => {
    return object.userData;
};
